export const PassRules = [
    `No mínimo 8 caracteres`,
    `No máximo 20 caracteres`,
    `Conter letras, números e caracteres especiais`,
    `Não pode ter mais de 3 números sequenciais`,
    `Não pode ter números repetidos em ordem`,
    `Não ser igual ao CPF, CNPJ, data de nascimento, telefone ou celular`,
]